<template>
  <div id="conteudo-questao" class="col-12 col-lg-6 questao order-2 order-md-2 pr-md-4 pl-md-4">
  <div class="img-questao text-center" v-if="questaoAtiva.imagensEnunciado && questaoAtiva.imagensEnunciado.length">
  <img v-for="imagem in questaoAtiva.imagensEnunciado"
       :src="imagem"
       alt="Texto explicando imagem detalhadamente"
       class="img-fluid d-inline-block m-3"/>
  </div>
  <p class="enunciado mt-4 mb-3" v-html="questaoAtiva.pergunta"></p>
  <div class="respostas mt-4">
  <div class="custom-control custom-checkbox" v-for="opcaoResposta in questaoAtiva.opcoes">
  <input type="checkbox" class="custom-control-input" :id="'resposta-'+opcaoResposta.id"
                         :value="opcaoResposta.id" v-model="respostaQuestao" @click="singleCheckbox($event, opcaoResposta)" >
                         <label class="custom-control-label" :for="'resposta-'+opcaoResposta.id"
                         :class="classOpcaoQuestao(opcaoResposta)">{{opcaoResposta.letra + '. ' + opcaoResposta.texto }}</label>
  </div>
</div>
<div class="comentario mt-4" v-if="exibirComentario && questaoAtiva.comentario">
<p class="tit-comentario">Comentário</p>
<div class="box-comentario">
  <p v-html="questaoAtiva.comentario"></p>
  <div class="imgs-comentario mt-3 row" v-if="questaoAtiva.imagensComentario && questaoAtiva.imagensComentario.length">
    <a v-for="imagem in questaoAtiva.imagensComentario"
       class="col-4 my-2"
       data-toggle="modal"
       data-target="#modalComentarioSimulado"
       @click="imagemModal = imagem">
      <img :src="imagem" alt="" class="img-fluid">
    </a>
  </div>
</div>
</div>
    <div class="modal fade" id="modalComentarioSimulado" tabindex="-1" role="dialog" aria-labelledby="modalComentarioSimulado" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <img :src="imagemModal" alt="Texto explicando imagem detalhadamente" class="img-fluid mx-auto d-block" />
      </div>
    </div>
</div>
</template>
<script>
import SimuladoAPI from '@/api/simulado-api'
import ImageUtils from '@/core/utils/image-utils'

export default {
  props: {
    quizId: Number,
    questoes: Array,
    desempenhoQuiz: Object
  },
  data () {
    return {
      imagemModal: '',
      nome: '',
      tipo: 0,
      tempo: { minutos: 0, segundos: 0 },
      respostaQuestao: [],
      respostaCorreta: null,
      exibirComentario: false,
      quantidadeQuestoes: 0,
      questaoAtiva: {},
      ordem: ''
    }
  },
  mounted () {
    window.eventBus.$on('selecionaQuestao', (data) => {
      this.questaoAtiva = this.mountQuestaoAtiva(data)
    })
  },
  computed: {
  },
  methods: {
    mountQuestaoAtiva: function (questao) {
      if (questao) {
        const questaoAtiva = {
          id: questao.id,
          pergunta: questao.enunciado,
          comentario: questao.comentario_feedback,
          opcoes: [],
          ordem: questao.ordem
        }

        if (questao.imagem_comentario && questao.imagem_comentario.length) {
          questaoAtiva.imagensComentario = questao.imagem_comentario && questao.imagem_comentario.length
            ? questao.imagem_comentario.map(item => ImageUtils.obterUrlCompletaImagem(item.arquivo, 'questoes-imagem/')) : []
        }

        if (questao.imagem_enunciado && questao.imagem_enunciado.length) {
          questaoAtiva.imagensEnunciado = questao.imagem_enunciado && questao.imagem_enunciado.length
            ? questao.imagem_enunciado.map(item => ImageUtils.obterUrlCompletaImagem(item.arquivo, 'questoes-imagem/')) : []
        }

        if (questao.opcao_respondida) {
          this.respostaQuestao = [questao.opcao_respondida]
        } else {
          this.respostaQuestao = []
        }

        this.exibirComentario = false

        this.respostaCorreta = questao.opcao_correta
        if (questao.opcao_respondida) {
          this.respostaCorreta = questao.opcao_correta
          this.exibirComentario = true
        }
        this.adicionarOpcaoQuestao(questaoAtiva.opcoes, 1, 'a', questao.resposta1)
        this.adicionarOpcaoQuestao(questaoAtiva.opcoes, 2, 'b', questao.resposta2)
        this.adicionarOpcaoQuestao(questaoAtiva.opcoes, 3, 'c', questao.resposta3)
        this.adicionarOpcaoQuestao(questaoAtiva.opcoes, 4, 'd', questao.resposta4)
        this.adicionarOpcaoQuestao(questaoAtiva.opcoes, 5, 'e', questao.resposta5)

        window.eventBus.$emit('selecionaQuestaoAtiva', questaoAtiva)
        return questaoAtiva
      }

      return { id: 0, pergunta: 'Não foi possível carregar esta questão, por favor entre em contato com o administrador do sitema' }
    },
    singleCheckbox: async function (event, opcao) {
      if (!event.target.checked) {
        this.respostaQuestao = []
        this.questoes.find(item => item.ordem === this.questaoAtiva.ordem).respondida = false
        this.questoes.find(item => item.ordem === this.questaoAtiva.ordem).opcao_respondida = null
        this.exibirComentario = false
        this.atualizaDesempenho()
        await SimuladoAPI.limparRespostaQuiz(this.quizId, this.questaoAtiva.ordem)
      } else {
        this.respostaQuestao = [opcao.id]
        this.questoes.find(item => item.ordem === this.questaoAtiva.ordem).respondida = true
        this.questoes.find(item => item.ordem === this.questaoAtiva.ordem).opcao_respondida = opcao.id
        this.exibirComentario = true
        this.atualizaDesempenho()
        await SimuladoAPI.registrarRespostaQuiz(this.quizId, this.questaoAtiva.ordem, opcao.id)
      }
    },
    atualizaDesempenho: function () {
      let corretas = 0
      let erradas = 0
      let naoRespondidas = 0
      for (let i = 0; i < this.questoes.length; i++) {
        if (this.questoes[i].opcao_correta === this.questoes[i].opcao_respondida) {
          corretas++
        } else {
          if (this.questoes[i].opcao_respondida == null) {
            naoRespondidas++
          } else {
            erradas++
          }
        }
      }
      this.desempenhoQuiz.questoes_acertadas = corretas
      this.desempenhoQuiz.questoes_incorretas = erradas
      this.desempenhoQuiz.questoes_sem_resposta = naoRespondidas
    },
    adicionarOpcaoQuestao: function (opcoes, id, letra, texto) {
      if (texto) {
        opcoes.push({ id: id, letra: letra, texto: texto })
      }
    },
    classOpcaoQuestao: function (opcao) {
      if (this.respostaQuestao.length) {
        if (opcao.id === this.respostaCorreta) {
          return 'text-success'
        } else if (this.respostaQuestao.includes(opcao.id)) {
          return 'text-danger'
        }
      }
    }
  }
}
</script>
